import React from 'react';
import { useIntl } from 'react-intl';
import { Box, Link, Text, useTheme } from '@chakra-ui/react';
import { Headline } from '@ldp-web/component-library/ui/molecules/headline';
import { Service } from '@/components/pharmacy-and-services/pharmacy-and-services.interface';

import styles from './services-list.module.scss';

const ServicesList: React.FC<{ data: Service[]; titleId: string; marginTop?: string; serviceType?: string }> = ({
  data,
  titleId,
  marginTop,
  serviceType,
}) => {
  const { common } = useTheme();
  const { formatMessage } = useIntl();
  const isGeneralServices = serviceType === 'generalServices';

  if (!data?.length) return null;

  const sortedServices = data?.sort((a: Service, b: Service) => a.name.localeCompare(b.name)) || [];

  return (
    <Box>
      <Headline
        title={formatMessage({ id: titleId })}
        data-testid={`${titleId}-headline`}
        headlineSize={4}
        style={{ marginTop }}
      />
      <div className={styles.services}>
        <div className={isGeneralServices ? styles.generalServicesContainer : styles.servicesContainer}>
          {sortedServices.map((service: Service) => (
            <Text
              key={`${service.name}-${service.url}`}
              data-testid="subHeading"
              {...common?.common02Regular}
              className={styles.serviceItem}
            >
              {service.url ? (
                <Link href={service.url} aria-label={`Link to ${service.name}`}>
                  {service.name}
                </Link>
              ) : (
                service.name
              )}
            </Text>
          ))}
        </div>
      </div>
    </Box>
  );
};

export default ServicesList;
